require('./../scripts/scrollWheel');

import {  manager, menu } from "../app";
import Hammer from 'hammerjs'

class VerticalSlider {

    constructor() {
        this.current = 0;
        this.timeOut = 500;
        this.wrapper = document.querySelector('.vertical-slider');
        this.pagination = document.querySelector('.vertical-slider .pagination');
        this.slides = null;
        this.hammer = null;
        this.isTransitioning = false;
        this.wheelCallback = this.wheelHandler.bind(this);
        this.inputCallback = this.inputHandler.bind(this);
        if( this.wrapper ) {
            this.setupSlider();
            return this;
        }

        return false;
    }

    setupSlider() {
        this.slides = this.wrapper.querySelectorAll('.slide');

        this.slides.forEach( (el, index) => {
            let active = '';
            if( index === 0 ) {
                el.classList.add('active');
                this.current = index;
                active = ' active';
            }

            this.pagination.appendChild( document.createRange().createContextualFragment(`
                    <span id="bullet-slide-${index}" data-slide="${index}" class="bullet${active}"></span>
                `) )
        } )

        this.pagination.appendChild( document.createRange().createContextualFragment((`
            <a href="#" id="slider-menu-toggle" class="button">Menu</a>
        `)));
        this.pagination.querySelectorAll('.bullet').forEach( e => e.addEventListener('click', this.navigate.bind(this) ) );
        this.pagination.querySelector('#slider-menu-toggle').addEventListener('click', menu.open.bind(menu));
        document.querySelectorAll('.slider-nav-button').forEach( e => e.addEventListener('click', this.navigate.bind(this) ) );
        addWheelListener( window, this.wheelCallback );
        document.addEventListener( 'keydown', this.inputCallback )
        this.hammer = new Hammer( this.wrapper.querySelector('.slider-wrapper') )
        this.hammer.on('swipe', ev => {
            console.log('swiping')
        })
    }

    destroy() {
        removeWheelListener( window, this.wheelCallback );
        document.removeEventListener( 'keydown', this.inputCallback )
        if( this.pagination ) {
            this.pagination.innerHTML = '';
        }
    }

    wheelHandler( event ) {
        event.preventDefault();
        if( this.isTransitioning ) return;
        if( Math.sign( event.deltaY ) === 1 ) {
            this.next();
        } else {
            this.prev();
        }
    }

    inputHandler( event ) {
        if( this.isTransitioning ) return;
        if( event.key === 'ArrowUp' || event.key === 'ArrowLeft' ) {
            this.prev()
        }
        if( event.key === 'ArrowDown' || event.key === 'ArrowRight' ) {
            this.next()
        }
    }

    goTo( index ) {
        this.isTransitioning = true;
        // play current slide out animation
        manager.getSlideTransition( this.current, this.slides[this.current].dataset.transition )
            .onReverseComplete( () => {
                // change slide opacities
                this.slides[this.current].style.opacity = 0;
                this.slides[index].style.opacity = 1;
                // change current slide index
                this.current = index;
                // play indexed slide in animation
                setTimeout( () => {
                    this.pagination.querySelector('.bullet.active').classList.remove('active');
                    this.pagination.querySelector('#bullet-slide-'+index).classList.add('active');
                }, this.timeOut / 2 );

                let _this = this;
                setTimeout( () => {
                    manager.getSlideTransition( index,
                        this.slides[index].dataset.transition ).onComplete(() => {
                            _this.isTransitioning = false;
                    }).play();

                    if( index + 1 === this.slides.length ) {
                        this.pagination.classList.add('show-menu');
                    } else if( this.pagination.classList.contains('show-menu') ) {
                        this.pagination.classList.remove('show-menu')
                    }
                }, this.timeOut )
            } ).reverse();
    }

    navigate( event ) {
        event.preventDefault();
        if( event.currentTarget.classList.contains('active') ) return;
        this.goTo( parseInt( event.currentTarget.dataset.slide ));
    }

    prev( e = false ) {
        // if is first slide, return
        if( this.current === 0 ) return;
        // get next slide index
        let prev = this.current - 1;
        // call goTo with index
        this.goTo( prev );
    }

    next( e = false) {
        let next = this.current + 1;
        // if is last slide, return
        if( next === this.slides.length ) return;
        // call goTo with index
        this.goTo( next );
    }

}
export default VerticalSlider;